// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"fe20e028","1373":"23fbc84c","3040":"43e9a5fe","7350":"36d9e990","7396":"43e9a5fe","7775":"fe20e028"}[chunkId] + ".chunk.css";
};